import React, { useEffect, useState } from 'react'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { useFeatureFlags } from '@node-space/hooks'
import { Box } from '@node-space/ui-components'
import {
  contactAtom,
  contactInstrumentActionAtom,
  contactInstrumentDecisionStepAtom,
} from 'pages/Contacts/atoms/contactAtoms'
import { Contact, ContactInstrumentDecisionStep, InstrumentType } from 'types/contacts'
import { ContactDecision } from './ContactDecision'
import { ContactForm } from './ContactForm'
import { ContactInstrumentForm } from './ContactInstrumentForm'

export const ContactInstrumentDecision = () => {
  const { t } = useTranslation()
  const { enableContactBankAccounts } = useFeatureFlags()

  const [isExistingContact, setIsExistingContact] = useState(false)

  const setContact = useSetAtom(contactAtom)
  const step = useAtomValue(contactInstrumentDecisionStepAtom)
  const [contactHandleStep, setContactHandleStep] = useAtom(contactInstrumentDecisionStepAtom)
  const [contactInstrumentAction, setContactInstrumentAction] = useAtom(contactInstrumentActionAtom)

  const showBack =
    contactHandleStep !== ContactInstrumentDecisionStep.CONTACT_DECISION &&
    !(contactHandleStep === ContactInstrumentDecisionStep.INSTRUMENT && !isExistingContact)

  const getSheetHeader = (): string => {
    switch (contactHandleStep) {
      case ContactInstrumentDecisionStep.CONTACT:
        return t(enableContactBankAccounts ? 'contacts.addContact' : 'contacts.addCryptoContact')
      case ContactInstrumentDecisionStep.CONTACT_DECISION:
        return t('contacts.existingContact')
      case ContactInstrumentDecisionStep.INSTRUMENT:
        return t('contacts.addCryptoAccount')
      default:
        return ''
    }
  }

  const handleContactSelect = (contact: Contact) => {
    setContact(contact)
    setIsExistingContact(true)
    setContactHandleStep(ContactInstrumentDecisionStep.INSTRUMENT)
  }

  const handleOnBack = () => {
    if (contactHandleStep === ContactInstrumentDecisionStep.CONTACT) {
      setContactHandleStep(ContactInstrumentDecisionStep.CONTACT_DECISION)
    }
    if (contactHandleStep === ContactInstrumentDecisionStep.INSTRUMENT) {
      setIsExistingContact(false)
      setContactHandleStep(ContactInstrumentDecisionStep.CONTACT_DECISION)
    }
    setContact(null)
  }

  useEffect(() => {
    setContactInstrumentAction({
      ...contactInstrumentAction,
      header: getSheetHeader(),
      onClose: () => {
        contactInstrumentAction?.onClose()
        setContactHandleStep(ContactInstrumentDecisionStep.CONTACT_DECISION)
      },
      onBack: showBack ? handleOnBack : null,
      meta: {
        ...contactInstrumentAction?.meta,
        flowType: InstrumentType.CRYPTO,
        handleContactSelect,
      },
    })
  }, [contactHandleStep])

  return (
    <Box width="full">
      {step === ContactInstrumentDecisionStep.CONTACT_DECISION && (
        <ContactDecision setIsExistingContact={setIsExistingContact} />
      )}
      {step === ContactInstrumentDecisionStep.CONTACT && <ContactForm />}
      {step === ContactInstrumentDecisionStep.INSTRUMENT && <ContactInstrumentForm />}
    </Box>
  )
}
